/* 

Before Login

*/

import react, { useEffect, useState } from 'react';
import { Text, Image, SimpleGrid, Box } from '@chakra-ui/react';

export function RoundY ({JsonX, isConnected}) {

    const [phaseColorGP, setPhaseColorGP] = useState()
    const [phaseColorWL, setPhaseColorWL] = useState()
    const [phaseColorPB, setPhaseColorPB] = useState()

    // const totalLeft =  JsonX.collectionSize - JsonX.totalSupply ;
    // const whitelistLeft = JsonX.maxWhitelistMinted + JsonX.teamSupply - JsonX.totalSupply ;
    // const team1 = JsonX.teamSupply + 1 ;
    // const team2 = JsonX.maxWhitelistMinted + JsonX.teamSupply ;
    

    useEffect(() => {

        runPhase()

    },[JsonX])

    function runPhase() {

        console.log("RUN PHASE")
        if ( JsonX.mintPhase == 0 ) {
            // 0 = not start yet
            // console.log("0 = not start yet")
            setPhaseColorGP("white")
            setPhaseColorWL("white")
            setPhaseColorPB("white")

        }
        else if ( JsonX.mintPhase == 1 ) {
            // 1 = WL Round
            // console.log("1 = WL Round")    
            setPhaseColorGP("#00cccc")
            setPhaseColorWL("white")
            setPhaseColorPB("white")
        }
        else if ( JsonX.mintPhase == 2 ) {
            // 2 = END WL Round
            // console.log("2 = END WL Round")
            setPhaseColorGP("gray")
            setPhaseColorWL("white")
            setPhaseColorPB("white")

        }
        else if (JsonX.mintPhase == 3) {
            // 3 = AL Round
            // console.log("3 = AL Round")
            setPhaseColorGP("gray")
            setPhaseColorWL("#00cccc")
            setPhaseColorPB("white")

        }
        else if (JsonX.mintPhase == 4) {
            // 4 = END AL Round
            // console.log("4 = END AL Round")
            setPhaseColorGP("gray")
            setPhaseColorWL("gray")
            setPhaseColorPB("white")

        }
        else if (JsonX.mintPhase == 5) {
            // 5 = PB Round
            // console.log("5 = PB Round")
            setPhaseColorGP("gray")
            setPhaseColorWL("gray")
            setPhaseColorPB("#00cccc")
        }
        else if (JsonX.mintPhase == 6) {
            // 6 = END PB Round
            // console.log("6 = END PB Round")
            setPhaseColorGP("gray")
            setPhaseColorWL("gray")
            setPhaseColorPB("gray")
        }
        else {
            // Else
            // console.log("Else")
            setPhaseColorGP("white")
            setPhaseColorWL("white")
            setPhaseColorPB("white")

        }
    }


    return(
        <>
            <SimpleGrid
                        columns={[1, null , 1]}
                        paddingLeft="0px"
                        paddingRight="0px"
                        margin="50px 0px"
            >

                        <Text
                            fontSize='5xl'
                            color="white"
                            fontWeight="800"
                        >Mint Schedule</Text>
                        <Text
                            fontSize='2xl'
                            color="white"
                            fontWeight="800"
                        >Max 10 NFT per Wallet</Text>

                        <Box
                            m="5px"
                            p="10px"
                            borderRadius="20px"
                            backgroundColor={phaseColorWL}
                        >
                            <Text fontSize='2xl' fontWeight="800" >Nova Round</Text>
                            {/* <Text fontSize='xl' fontWeight="600">Time : JUNE 11, 07:00 PM  (UTC+7)</Text> */}
                            <Text fontSize='xl' fontWeight="600">WL = 1 Free NFT </Text>
                            <Text fontSize='xl' fontWeight="600">(+additional 0.002 per 1 NFT)</Text>
                            <Text fontSize='xl' fontWeight="600">No WL = 0.002 ETH</Text>
                            {/* <Text color="green" fontWeight="600"><a target='_blank' href='https://time.is/Bangkok'>Check in your time zone</a></Text> */}
                        </Box>


                    </SimpleGrid>

                
         
      
        </>

    )

}